import React, { Component } from 'react';
import { Route, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import common from '~/common';
import Actions from '~/Actions';

import '~/font.css';
import CheckLogoutDialog from '~/containers/Page_Main/CheckLogoutDialog';
import DataList from './TreeList/DataList';
import TreeList from './TreeList';
import TitleBar from './TitleBar';
import PageLabel from './PageLabel';
import Page_Map from './Page_Map';

class App extends Component {
  state={ treeList_hide: false, checkLogout: false, contentOpacity: 0, current_id: '' }

  componentDidMount () {
    const { getAtyFunction } = this.props;
    getAtyFunction();

    this.deadLine = new Date(new Date().setMinutes(new Date().getMinutes() + 30));
    window.addEventListener('mousemove', this.handleMouseMove);
    this.logoutTimer = setInterval(() => {
      const { check = {} } = this.props;
      const { token_exp = '' } = check;
      let check_deadline = token_exp.replace(' ', 'T');
      while (check_deadline.match('/')) {
        check_deadline = check_deadline.replace('/', '-');
      }
      if (new Date() > this.deadLine || (token_exp.length > 0 && new Date() > new Date(check_deadline))) { this.logout(); }
    }, 1000);
  }

  componentDidUpdate (preProps) {
    const { history } = this.props;
    if (history.location.pathname !== this.path) {
      this.path = history.location.pathname;
      this.setState({ contentOpacity: 0 });
      this.fadeIn();
    }
  }

  componentWillUnmount () {
    const { clearKey } = this.props;
    window.removeEventListener('mousemove', this.handleMouseMove);
    clearInterval(this.logoutTimer);
    // clearKey('AtyFunction');
    // clearKey('PathAry');
  }

  logout=() => {
    const { getLogout, clearSession, clearJwtKey, history } = this.props;
    getLogout();
    clearSession();
    clearJwtKey('Check');
    localStorage.removeItem('token');
    localStorage.removeItem('refresh_token');
    history.push(`${common.rootPath}/Login`);
  }

  handleMouseMove = e => { this.deadLine = new Date(new Date().setMinutes(new Date().getMinutes() + 30)); }

  _clickTreeBtn=() => this.setState({ treeList_hide: !this.state.treeList_hide })

  fadeIn=() => {
    const timer = setInterval(() => {
      this.setState({ contentOpacity: 1 });
      clearInterval(timer);
    }, 10);
  }

  render () {
    const { checkLogout, current_id, treeList_hide, contentOpacity } = this.state;
    // const { pathAry = [] } = this.props;
    return (
      <div style={{ width: '100%', height: '100%', display: 'flex', flexDirection: 'column', backgroundColor: 'white' }}>
        <TitleBar onLogout={() => this.setState({ checkLogout: true })} onClickTreeBtn={this._clickTreeBtn} />
        <div id="view_main" style={{ flex: 1, display: 'flex', overflow: 'hidden' }}>
          <TreeList hide={treeList_hide} />
          <div id="content_main" style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
            <PageLabel />
            <div style={{ flex: 1, position: 'relative', opacity: contentOpacity, transition: contentOpacity > 0 ? 'opacity 1s' : 'none' }}>
              <Route exact path={`${common.rootPath}/Gis`} component={Page_Map} />
              {DataList.map((o1, i1) => o1.detail.map((o2, i2) => {
                if (o2.detail.length > 0) {
                  return o2.detail.map((o3, i3) => <Route key={`/Gis/${o1.path}/${o2.path}/${o3.path}`} exact path={`${common.rootPath}/Gis/${o1.path}/${o2.path}/${o3.path}`} component={o3.page} />);
                } else {
                  return <Route key={`/Gis/${o1.path}/${o2.path}`} exact path={`${common.rootPath}/Gis/${o1.path}/${o2.path}`} component={o2.page} />;
                }
              }))}
            </div>
            {/* <div style={{ marginBottom: 22.8, fontSize: 16, lineHeight: '23.17px', color: '#186279' }}>{`© 2022 ${common.frontTitle} All rights reserved.`}</div> */}
            <div style={{ marginBottom: 22.8, fontSize: 16, lineHeight: '23.17px', color: '#186279' }}>{`© ${common.frontTitle} All rights reserved.`}</div>
          </div>
        </div>
        {/* <div style={{ flex: 1 }}>
          <Map setId={id => this.setState({ current_id: id })} />
        </div>
        <Detail current_id={current_id} onClose={() => this.setState({ current_id: '' })} /> */}
        <CheckLogoutDialog open={checkLogout} onCheck={this.logout} onCancel={() => this.setState({ checkLogout: false })} />
      </div>
    );
  }
}
const mapStateToProps = state => ({
  check: state.JWT.Check,
  // pathAry: state.data.PathAry,
});
const mapDispatchToProps = dispatch => ({
  getLogout: () => Actions.getLogout(dispatch),
  clearSession: () => dispatch(Actions.clearSession()),
  getAtyFunction: () => Actions.getAtyFunction(dispatch),
  clearJwtKey: key => Actions.clearJwtKey(dispatch, { key }),
  clearKey: key => Actions.clearKey(dispatch, { key }),
});
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(App));
